import styled from 'styled-components';
export var ItemContainer = styled.div.withConfig({
  displayName: "style__ItemContainer",
  componentId: "qofjek-0"
})(["position:relative;width:100%;margin-left:", ";"], function (props) {
  return props.tab ? '20px' : '10px';
});
export var Item = styled.div.withConfig({
  displayName: "style__Item",
  componentId: "qofjek-1"
})(["margin:0;padding:0;height:36px;display:flex;position:relative;flex-direction:row;align-items:center;", ":hover &{background:rgba(196,196,191,0.15);}margin-left:", ";"], ItemContainer, function (props) {
  return props.left ? props.left : '5px';
});
export var InputContainer = styled.div.withConfig({
  displayName: "style__InputContainer",
  componentId: "qofjek-2"
})(["order:0;width:10%;margin-left:5px;height:100%;display:flex;align-items:center;"]);
export var DropdownContainer = styled.div.withConfig({
  displayName: "style__DropdownContainer",
  componentId: "qofjek-3"
})(["margin-left:5px;"]);
export var IconContainer = styled.div.withConfig({
  displayName: "style__IconContainer",
  componentId: "qofjek-4"
})(["order:1;margin:0;width:10%;padding:0;position:relative;"]);
export var LabelContainer = styled.div.withConfig({
  displayName: "style__LabelContainer",
  componentId: "qofjek-5"
})(["order:1;margin:0;width:", ";padding:0;position:relative;"], function (props) {
  return props.width ? props.width : '70%';
});
export var CheckboxContainer = styled.div.withConfig({
  displayName: "style__CheckboxContainer",
  componentId: "qofjek-6"
})(["order:0;width:10%;margin-left:5px;height:100%;display:flex;align-items:center;"]);